import Text from 'Components/Atoms/Text/Text';
import React from 'react';
import { STATUS } from 'Services/Status/Status.types';
import { SUBSTATUS } from 'Services/Status/Substatus.types';
import styles from './StatusLabel.module.sass';

const StatusLabel = ({
    label, children,
    status, substatus,
    ...props
}: Props) => {

    return <div
        className={`
            ${styles['statuslabel']}
            ${styles['statuslabel__status--'+(STATUS.getLabelByValue(STATUS.getStatusBySubStatus(substatus))?.toLowerCase())]}
            ${styles['statuslabel__status--'+status?.toLowerCase()]}
        `}
        {...props}
    >
        <Text>
            { children ?? SUBSTATUS.getLabelByValue(label ?? substatus) }
        </Text>
    </div>;
}

interface Props {
    children?: any
    label?: any
    status?: any
    substatus?: any
}

export default React.memo(StatusLabel);